import { render, staticRenderFns } from "./dog-and-cat-grooming-communicating-with-pet-owners.vue?vue&type=template&id=0b082633&"
import script from "./dog-and-cat-grooming-communicating-with-pet-owners.vue?vue&type=script&lang=js&"
export * from "./dog-and-cat-grooming-communicating-with-pet-owners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports